
/**
 * Module dependencies.
 */

import { createAction } from 'redux-actions'
import request from 'superagent'
import fetch from 'lib/fetch'

/**
 * Action types.
 */

export const REQUEST_METADATA_OWNERS = 'REQUEST_METADATA_OWNERS'
export const RECEIVE_METADATA_OWNERS = 'RECEIVE_METADATA_OWNERS'
export const FETCH_METADATA_OWNERS_ERROR = 'FETCH_METADATA_OWNERS_ERROR'
export const REMOVE_METADATA_OWNER_ERROR = 'REMOVE_METADATA_OWNER_ERROR'
export const ADD_METADATA_OWNER_ERROR = 'ADD_METADATA_OWNER_ERROR'
export const INVALIDATE_METADATA_OWNERS = 'INVALIDATE_METADATA_OWNERS'

/**
 * Actions.
 */

const requestMetadataOwners = createAction(REQUEST_METADATA_OWNERS)
const fetchMetadataOwnersError = createAction(FETCH_METADATA_OWNERS_ERROR)
const receiveMetadataOwners = createAction(RECEIVE_METADATA_OWNERS)
const invalidateMetadataOwners = createAction(INVALIDATE_METADATA_OWNERS)
const removeMetadataOwnerError = createAction(REMOVE_METADATA_OWNER_ERROR)
const addMetadataOwnerError = createAction(ADD_METADATA_OWNER_ERROR)

/**
 * Fetch owners for  metadata `metadataType` and `slug` (if needed).
 */

export function fetchMetadataOwnersIfNeeded ({ metadataType, slug }) {
  return function (dispatch, getState) {
    const state = getState()
    if (shouldFetchMetadataOwners(metadataType, slug, state)) {
      return dispatch(fetchMetadataOwners({ metadataType, slug }))
    }
  }
}

/**
 * Should fetch list?
 */

function shouldFetchMetadataOwners (metadataType, slug, state) {
  const owners = state.metadatasOwnersBySlug[metadataType][slug]
  if (!owners) return true
  if (owners.isRequesting) return false
  return true
}

/**
 * Fetch owners for metadata `metadataType` and `slug`.
 */

function fetchMetadataOwners ({ metadataType, slug }) {
  return function (dispatch) {
    dispatch(requestMetadataOwners({ metadataType, slug }))
    request
    .get(`/api/metadata/${metadataType}/${slug}/owners`)
    .end(function (err, res) {
      if (err || !res.ok) {
        const error = err || new Error(`Unable to fetch owners for "${metadataType}/${slug}" (${res.status})`)
        dispatch(fetchMetadataOwnersError({ metadataType, slug, error }))
      } else {
        dispatch(receiveMetadataOwners({ metadataType, slug, data: res.body }))
      }
    })
  }
}

/**
 * Remove owner.
 */

export function removeMetadataOwner ({ metadataType, slug, userId }) {
  return function (dispatch) {
    dispatch(invalidateMetadataOwners({ metadataType, slug }))

    fetch(`/api/metadata/${metadataType}/${slug}/owners/${userId}`, {
      method: 'DELETE'
    })
    .then(res => {
      if (!res.ok) {
        throw new Error(`Unable to remove owner "${userId}" from "${metadataType}/${slug}" (${res.status})`)
      }
      return res.json()
    })
    .then(data => {
      dispatch(receiveMetadataOwners({ metadataType, slug, data }))
    })
    .catch(error => {
      dispatch(removeMetadataOwnerError({ metadataType, slug, error }))
    })
  }
}

/**
 * Add owner.
 */

export function addMetadataOwner ({ metadataType, slug, email }) {
  return function (dispatch) {
    dispatch(invalidateMetadataOwners({ metadataType, slug }))

    fetch(`/api/metadata/${metadataType}/${slug}/owners`, {
      method: 'PUT',
      body: JSON.stringify({ email })
    })
    .then(res => {
      if (!res.ok) {
        throw new Error(`Unable to add owner "${email}" to "${metadataType}/${slug}" (${res.status})`)
      }
      return res.json()
    })
    .then(data => {
      dispatch(receiveMetadataOwners({ metadataType, slug, data }))
    })
    .catch(error => {
      dispatch(addMetadataOwnerError({ metadataType, slug, error }))
    })
  }
}



// WEBPACK FOOTER //
// ./actions/metadata-owners.js